export { SiteFilterActionType } from './site-filter-action-type.enum';

import { DeleteManagementSiteFilterItem, DeleteManagementSiteFilterItemCompleted, DeleteManagementSiteFilterItemFailed } from './site-filter-delete.action';
import { LoadSiteFilter, LoadSiteFilterCompleted, LoadSiteFilterFailed } from './site-filter-load.action';
import {
  UpdateManagementSiteFilterItem,
  UpdateManagementSiteFilterItemCompleted,
  UpdateManagementSiteFilterItemFailed,
  UpdateManagmentSiteFilterCategory,
  UpdateManagmentSiteFilterCategoryCompleted,
  UpdateManagmentSiteFilterCategoryFailed,
  UpdateSiteFilter,
  UpdateSiteFilterCompleted,
  UpdateSiteFilterFailed } from './site-filter-update.action';

export type SiteFilterActions =

  LoadSiteFilter |
  LoadSiteFilterCompleted |
  LoadSiteFilterFailed |

  UpdateSiteFilter |
  UpdateSiteFilterCompleted |
  UpdateSiteFilterFailed |

  UpdateManagmentSiteFilterCategory |
  UpdateManagmentSiteFilterCategoryCompleted |
  UpdateManagmentSiteFilterCategoryFailed |

  UpdateManagementSiteFilterItem |
  UpdateManagementSiteFilterItemCompleted |
  UpdateManagementSiteFilterItemFailed |

  DeleteManagementSiteFilterItem |
  DeleteManagementSiteFilterItemCompleted |
  DeleteManagementSiteFilterItemFailed;
